import(/* webpackMode: "eager", webpackExports: ["FunnyFortunePageContent"] */ "/vercel/path0/app/funny-fortune-cookie-messages/FunnyFortunePageContent.tsx");
